// extracted by mini-css-extract-plugin
module.exports = {"title":"parties-module--title--2xCP4","eventStream":"parties-module--eventStream--18Kxp","eventFrame":"parties-module--eventFrame--2RnVE"};